import { CircleCheck } from 'lucide-react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@predoc/cow';
import { PATIENT_REQUEST_STEPS } from '../constants';
import { Fragment } from 'react/jsx-runtime';
import { usePatientRequestContext } from '../context/usePatientRequestContext';

export const StepperHeader = () => {
  const { currentStepIndex } = usePatientRequestContext();

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {PATIENT_REQUEST_STEPS.map((step, index) => {
          const isCurrentStep = currentStepIndex === index;
          const isCompleted = currentStepIndex > index;
          const isLastStep = index === PATIENT_REQUEST_STEPS.length - 1;

          return (
            <Fragment key={`fragment-${step.id}`}>
              <BreadcrumbItem>
                {isCurrentStep ? (
                  <BreadcrumbPage className="flex items-center gap-2">
                    {isCompleted && (
                      <CircleCheck className="h-4 w-4 text-green-500" />
                    )}
                    {step.title}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink className="flex items-center gap-2">
                    {isCompleted && (
                      <CircleCheck className="h-4 w-4 text-green-500" />
                    )}
                    {step.title}
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
              {!isLastStep && (
                <BreadcrumbSeparator key={`separator-${step.id}`} />
              )}
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};
